// 文件: assets/accordion-smooth.js

(() => {
  // 初始化平滑折叠面板
  function initSmoothAccordions() {
    document.querySelectorAll('.accordion details').forEach(details => {
      const content = details.querySelector('.accordion__content');
      const summary = details.querySelector('summary');
      
      // 检查是否应该初始展开
      const shouldBeOpen = details.getAttribute('data-open') === 'open';
      
      // 设置初始状态
      if (!shouldBeOpen) {
        // 默认关闭状态
        details.open = false;
        content.style.height = '0px';
        content.style.opacity = '0';
        content.style.padding = '0 1rem 0';
      } else {
        // 应该展开的状态
        details.open = true;
        content.style.height = 'auto';
        content.style.opacity = '1';
        content.style.padding = '';
      }
      
      // 重新绑定点击事件，避免重复绑定
      summary.removeEventListener('click', handleClick);
      summary.addEventListener('click', handleClick);
      
      // 点击处理函数
      function handleClick(e) {
        e.preventDefault();
        
        if (details.open) {
          // 关闭面板
          content.style.height = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            content.style.height = '0px';
            content.style.opacity = '0';
            content.style.paddingTop = '0';
            content.style.paddingBottom = '0';
          });
          
          content.addEventListener('transitionend', function closePanel() {
            details.open = false;
            content.removeEventListener('transitionend', closePanel);
          }, {once: true});
        } else {
          // 打开面板
          details.open = true;
          requestAnimationFrame(() => {
            content.style.height = content.scrollHeight + 'px';
            content.style.opacity = '1';
            content.style.paddingTop = '';
            content.style.paddingBottom = '';
          });
          
          content.addEventListener('transitionend', function setAutoHeight() {
            if (details.open) content.style.height = 'auto';
            content.removeEventListener('transitionend', setAutoHeight);
          }, {once: true});
        }
      }
    });
  }
  
  // 在DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothAccordions);
  } else {
    initSmoothAccordions();
  }
  
  // 兼容Shopify主题编辑器
  document.addEventListener('shopify:section:load', initSmoothAccordions);
  
  // 暴露全局方法供手动调用
  window.refreshAccordions = initSmoothAccordions;
})();